export default {
  menu: 'Transfers',
  title: 'Transfers',

  general: {
    table: {
      header: {
        row: 'Row',
        date: 'Date',
        description: 'Description',
        invoiceId: 'Invoice No.',
        status: 'Status',
        creator: 'Creator',
        barcode: 'Barcode',
        name: 'Name',
        sourceWarehouse: 'Source warehouse',
        destinationWarehouse: 'Destination warehouse',
        count: 'Qty',
        delete: 'Delete',
        restore: 'Restore'
      }
    },

    labels: {
      allProduct: 'All products',
      sourceWarehouse: 'Source warehouse',
      destinationWarehouse: 'Destination warehouse',
      id: 'ID',
      registryDate: 'Registry date',
      type: 'Type',
      creator: 'Creator',
      status: 'Status'
    },

    notifications: {
      isExists: {
        message: 'This value is in the list',
        dynamicMessage: 'There are {name} in the list'
      },

      increaseCount: {
        message: 'Number of items added',
        dynamicMessage: 'Number of { names } added'
      },

      productNotFount: 'No product found with this barcode',
      quantity: 'Inventory is not enough!',
      dynamicQuantity: 'There is not enough stock of {name}!',

      insert: {
        success: 'Warehouse transfer registered successfully',
        error: 'Warehouse transfer registration was incorrect!'
      },

      edit: {
        success: 'Warehouse transfer edited successfully',
        error: 'Warehouse transfer editing encountered an error!'
      },

      delete: {
        success: 'Warehouse transfer successfully deleted',
        error: 'Deleting the warehouse transfer was accompanied by an error'
      },

      restore: {
        success: 'Warehouse transfer successfully restored',
        error: 'Restore warehouse transfer was accompanied by an error'
      },

      parseError: {
        storeroom: 'Warehouse not selected!',
        stocks: 'No items selected!',
        description: 'Description field is empty!',
        invoiceNumber: 'This invoice number is already selected!',
        quantity: 'The number of selected products is not valid!',
        noProductEnter: 'No Product Selected!'
      }
    },

    confirmations: {
      delete: {
        title: 'Confirmation of deletion of warehouse transfer',
        body: 'If the warehouse transfer is deleted, all the documents and delivery note of the warehouse related to the invoice will be deleted. Are you sure? '
      },
      forceDelete: {
        title: 'Confirmation of deletion of invoice',
        body: 'If the invoice is deleted, the information of invoice deleted and cant restore it. Are you sure? '
      },
      forceUpdate: {
        title: 'Warehouse transfer edit confirmation',
        body: 'By edit warehouse transfer, All documents related to this invoice change. Are you sure of confirming edit warehouse transfer?'
      }
    },

    types: {
      deficit: 'Deficit',
      surplus: 'Surplus'
    },

    statusTypes: {
      draft: 'Draft',
      incomplete: 'Exit from source warehouse',
      confirmed: 'Receipt to destination warehouse',
      deleted: 'Deleted'
    }
  },

  list: {
    title: 'Transfers'
  },

  trash: {
    title: 'Removed Warehouse Transfer List'
  },

  insert: {
    title: 'Insert Warehouse Transfer'
  },

  profile: {
    title: 'Warehouse Transfer Profile'
  },

  edit: {
    title: 'Edit Warehouse Transfer'
  },

  logs: {
    title: 'Warehouse Transfer Logs'
  }
}
